export const locKeys = {
  flightPreferredAirlineLabel: "wizard.package.preferredFlightAirline.label",
};
